'use strict';

module.exports = function () {
    $('.js-store-country-select').on('change', function () {
        var selectedLink = $(this).val();
        if (selectedLink) {
            $.spinner().start();
            $('.js-country-selector')?.removeClass('show');
            window.location.href = selectedLink;
        }
    });
};
